module.exports = __webpack_public_path__ + "luanova.jpg?76f7e3aa2e1440e4ed647852e28b5eef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/luanova.jpg
// module id = 131
// module chunks = 0